export const EMPTY_DRAWING_SVG = `
<svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M150 50H50C47.2386 50 45 52.2386 45 55V145C45 147.761 47.2386 150 50 150H150C152.761 150 155 147.761 155 145V55C155 52.2386 152.761 50 150 50Z" stroke="#6366F1" stroke-width="2"/>
  <path d="M70 90L90 110L130 70" stroke="#6366F1" stroke-width="2"/>
  <circle cx="100" cy="100" r="35" stroke="#6366F1" stroke-width="2" stroke-dasharray="4 4"/>
</svg>
`;

export const EMPTY_NOTES_SVG = `
<svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M150 40H50C47.2386 40 45 42.2386 45 45V155C45 157.761 47.2386 160 50 160H150C152.761 160 155 157.761 155 155V45C155 42.2386 152.761 40 150 40Z" stroke="#6366F1" stroke-width="2"/>
  <line x1="65" y1="70" x2="135" y2="70" stroke="#6366F1" stroke-width="2"/>
  <line x1="65" y1="90" x2="135" y2="90" stroke="#6366F1" stroke-width="2"/>
  <line x1="65" y1="110" x2="115" y2="110" stroke="#6366F1" stroke-width="2"/>
</svg>
`; 